<template>
  <div
    style="width:181px;background-color:white;"
    class="pb-2"
  >
    <v-list
      dense
      style="max-height:200px;overflow-y:auto;"
    >
      <v-list-item
        v-for="(item, i) in filterItems"
        :key="i"
        ripple
        link
        @click="setSelected(i, item.value)"
      >
        <v-list-item-action class="mr-1 mb-1">
          <v-checkbox
            v-model="selected[i]"
            :ripple="false"
            color="success"
            @click.stop.prevent
          />
        </v-list-item-action>
        <v-list-item-title
          color="muted"
          class="mt-2"
        >
          {{ item.name }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
    <v-btn
      color="primary"
      class="d-block mx-auto mt-2"
      :disabled="disableSubmit"
      @click="applySelection"
    >
      Apply
    </v-btn>
  </div>
</template>
<script>
  export default {
    name: 'MultiselectFilter',
    props: {
      items: {
        type: Array,
      },
      filterKey: String,
    },
    data: () => ({
      filterItems: [],
      selected: [],
    }),
    computed: {
      disableSubmit () {
        return !this.filterItems.length
      },
    },
    created () {
      this.filterItems = this.items
    },
    methods: {
      setSelected (idx, value) {
        if (this.selected[idx]) {
          this.selected[idx] = false
        } else {
          this.selected[idx] = true
        }
        this.$forceUpdate()
      },
      applySelection () {
        const selectedFilters = this.filterItems.reduce((acc, item, i) => this.selected[i] ? [item.value, ...acc] : acc, [])
        const payload = { key: this.filterKey, operator: 'in', value: selectedFilters.join(',') }
        this.$emit('apply-multiselect', payload)
        // Force closes menu after selection
        this.$parent.$parent.save()
      },
    },
  }
</script>
<style lang="scss">

</style>
